<template>
  <basic-container id="carcoupongiveouts">
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      v-model="form"
      :search.sync="searchForm"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot="couponNameSearch">
        <el-select v-model="couponId" style="width: 100%" placeholder="优惠券名称">
          <el-option
            v-for="item in couponShopRecordList"
            :key="item.couponId"
            :label="item.couponName"
            :value="item.couponId"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="totalCouponsSearch" span="6">
        <el-input v-model="totalCoupons" disabled></el-input>
      </template>
      <template slot="usedCouponsSearch" span="6">
        <el-input v-model="usedCoupons" disabled></el-input>
      </template>
      <template slot="shopBalanceSearch" span="6">
        <el-input v-model="shopBalance" disabled></el-input>
      </template>

      <template slot-scope="scope" slot="parkingLotIdSearch">
        <selectSearch  v-model="parkingLotIdQuery" :dicData="spaceList" @change="parkingLotQueryChanged"></selectSearch>
        <!-- <el-select
          v-model="parkingLotIdQuery"
          filterable
          @change="parkingLotQueryChanged"
          style="width: 100%"
          placeholder="车场名称"
        >
          <el-option v-for="item in spaceList" :key="item.id" :label="item.title" :value="item.id">
          </el-option>
        </el-select> -->
      </template>
      <template slot-scope="scope" slot="shopIdSearch">
        <el-select
          v-model="shopId"
          style="width: 100%"
          placeholder="商家名称"
          @change="searchShopChange"
        >
          <el-option
            v-for="item in shopSelectionsList"
            :key="item.id"
            :label="item.shopName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      <template slot-scope="scope" slot="giveOutTimeRangeSearch">
        <div style="display: flex;">
                              <el-date-picker
                                    style="width:42%;"
                                    v-model="qtimeStart"
                                    type="datetime"
                                    default-time="00:00:00"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    range-separator="到"
                                    placeholder="开始日期"

                                  >
                                  </el-date-picker>
                                  到
                                  <el-date-picker
                                    style="width:42%;"
                                    v-model="qtimeEnd"
                                    type="datetime"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    default-time="23:59:59"

                                    placeholder="结束日期"
                                  >
                                  </el-date-picker>
                            </div>

      </template>
      <template slot="menuLeft">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="beforeOpen('add')"
          >新增
        </el-button>
        <!--        <el-button type="primary"
                           size="small"
                           @click="sendCouponsToCar(scope.row)">发券
                </el-button>-->
      </template>
      <template slot="menu" slot-scope="scope">
        <!--        <el-button type="text"-->
        <!--                   size="small"-->
        <!--                   @click="beforeOpen('edit',scope.row)">编辑-->
        <!--        </el-button>-->
        <el-button type="text" size="small" @click="getQrcode(scope.row.id, scope.row.shopName)"
          >二维码
        </el-button>
        <el-button type="text" size="small" @click="openSendCouponDialog(scope.row)"
          >发券
        </el-button>
      </template>
    </avue-crud>
    <el-dialog
      id="coupon_give_out"
      :title="title"
      :visible.sync="showCouponGiveOutDialog"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      append-to-body
      width="50%"
      @close="closeDialog"
    >
      <el-row v-if="showCouponGiveOutDialog">
        <el-form ref="giveOutForm" :model="giveOutForm" label-width="180px" margin-top="0">
          <el-col span="12">
            <el-form-item
              label="车场名称"
              prop="parkingLotId"
              :rules="[{ required: true, message: '请选择车场名称', trigger: 'change' }]"
            >
            <selectSearch  v-model="giveOutForm.parkingLotId" :dicData="spaceList" @change="giveOutParkingLotChange"></selectSearch>
              <!-- <el-select
                v-model="giveOutForm.parkingLotId"
                style="width: 100%"
                placeholder="车场名称"
                :disabled="disabled"
                @change="giveOutParkingLotChange"
              >
                <el-option
                  v-for="item in spaceList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select> -->
            </el-form-item>
          </el-col>

          <el-col span="12">
            <el-form-item
              label="商家名称"
              prop="shopId"
              :rules="[{ required: true, message: '请选择商家名称', trigger: 'change' }]"
            >
              <el-select
                v-model="giveOutForm.shopId"
                style="width: 100%"
                placeholder="商家名称"
                :disabled="disabled"
                @change="shopChanged"
              >
                <el-option
                  v-for="item in shopNormalList"
                  :key="item.id"
                  :label="item.shopName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item
              label="优惠券名称"
              prop="couponId"
              :rules="[{ required: true, message: '请选择优惠券', trigger: 'change' }]"
            >
              <el-select
                v-model="giveOutForm.couponId"
                style="width: 100%"
                placeholder="优惠券"
                filterable
                @change="chopChanged"
              >
                <el-option
                  v-for="item in couponList"
                  :key="item.couponId"
                  :label="item.couponName"
                  :value="item.couponId"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item
              label="优惠券有效期"
              prop="couponExpireDate"
              :rules="[{ required: true, message: '请选择优惠券有效期', trigger: 'blur' }]"
            >
              <el-date-picker
                v-model="giveOutForm.couponExpireDate"
                type="datetime"
                style="width: 100%"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item
              label="优惠券数量"
              prop="couponNum"
              :rules="[{ required: true, message: '请输入优惠券数量', trigger: 'blur' }]"
            >
              <el-input
                v-model="giveOutForm.couponNum"
                placeholder="请输入优惠券数量"
                type="number"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item
              label="同一用户领取优惠券数量"
              prop="onePersonGetCouponNum"
              :rules="[{ required: true, message: '请选择用户领券数量', trigger: 'change' }]"
            >
              <el-select
                v-model="giveOutForm.onePersonGetCouponNum"
                style="width: 100%"
                placeholder="请选择用户领券数量"
                filterable
              >
                <el-option
                  v-for="item in onePersonGetCouponNumList"
                  :key="item.onePersonGetCouponNum"
                  :label="item.onePersonGetCouponNum"
                  :value="item.onePersonGetCouponNum"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="领用时车辆必须在场" required valid="inspectCycleType">
              <el-radio-group v-model="giveOutForm.getCouponIsCarIn">
                <el-radio :label="0">是</el-radio>
                <el-radio :label="1">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item
              label="二维码截至"
              prop="expireDate"
              :rules="[{ required: true, message: '请选择二维码截止时间', trigger: 'blur' }]"
            >
              <el-date-picker
                v-model="giveOutForm.expireDate"
                type="datetime"
                style="width: 100%"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col span="24">
            <el-form-item
              label="备注信息"
              prop="remark"
              :rules="[{ required: false, message: '请输入备注信息', trigger: 'blur' }]"
            >
              <el-input
                v-model="giveOutForm.remark"
                placeholder="请输入备注信息"
                type="textarea"
                :row="4"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div style="float: right">
              <el-button type="primary" icon="el-icon-plus" @click="saveData" size="small"
                >保存</el-button
              >
              <el-button icon="el-icon-delete" @click="showCouponGiveOutDialog = false" size="small"
                >取消</el-button
              >
            </div>
          </el-col>
        </el-form>
      </el-row>
    </el-dialog>
    <el-dialog
      id="coupon_give_out_to_car"
      :title="'发券'"
      :visible.sync="showCouponGiveOutToCarDialog"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      append-to-body
      width="50%"
    >
      <el-row v-if="showCouponGiveOutToCarDialog">
        <el-form ref="giveOutForm" :model="giveOutForm" label-width="150px" margin-top="0">
          <el-col span="12">
            <el-form-item
              label="车场名称"
              prop="parkingLotId"
              :rules="[{ required: true, message: '请选择车场名称', trigger: 'change' }]"
            >
              <el-select
                v-model="giveOutForm.parkingLotId"
                style="width: 100%"
                placeholder="车场名称"
                :disabled="disabled"
                @change="giveOutParkingLotChange"
              >
                <el-option
                  v-for="item in spaceList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col span="12">
            <el-form-item
              label="商家名称"
              prop="shopId"
              :rules="[{ required: true, message: '请选择商家名称', trigger: 'change' }]"
            >
              <el-select
                v-model="giveOutForm.shopId"
                style="width: 100%"
                placeholder="商家名称"
                :disabled="disabled"
                @change="shopChanged"
              >
                <el-option
                  v-for="item in shopNormalList"
                  :key="item.id"
                  :label="item.shopName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item
              label="优惠券名称"
              prop="couponId"
              :rules="[{ required: true, message: '请选择优惠券', trigger: 'change' }]"
            >
              <el-select
                v-model="giveOutForm.couponId"
                style="width: 100%"
                placeholder="优惠券"
                :disabled="disabled"
                filterable
              >
                <el-option
                  v-for="item in couponList"
                  :key="item.couponId"
                  :label="item.couponName"
                  :value="item.couponId"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item
              label="优惠券有效期"
              prop="couponExpireDate"
              :rules="[{ required: true, message: '请选择优惠券有效期', trigger: 'blur' }]"
            >
              <el-date-picker
                v-model="giveOutForm.couponExpireDate"
                type="datetime"
                style="width: 100%"
                :disabled="disabled"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="领用时车辆必须在场" required valid="inspectCycleType">
              <el-radio-group v-model="giveOutForm.getCouponIsCarIn" :disabled="disabled">
                <el-radio :label="0">是</el-radio>
                <el-radio :label="1">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col span="24">
            <el-form-item
              label="车牌号"
              prop="plateNumberList"
              :rules="[
                {
                  required: true,
                  message: '请输入车牌号，多个车牌号使用英文”,“隔开',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                v-model="giveOutForm.plateNumberList"
                placeholder="请输入车牌号，多个车牌号使用英文”,“隔开"
                type="text"
              ></el-input>
            </el-form-item>
          </el-col>
          <!--          <el-col span="4" align="center">
                      <el-button type="default"
                                 size="small"
                                 @click="sendCouponsToCar">批量导入
                      </el-button>
                    </el-col>-->
          <el-col :span="24">
            <div style="float: right">
              <el-button type="primary" icon="el-icon-plus" @click="sendCouponsToCar" size="small"
                >发券</el-button
              >
              <el-button
                icon="el-icon-delete"
                @click="showCouponGiveOutToCarDialog = false"
                size="small"
              >
                取消
              </el-button>
            </div>
          </el-col>
        </el-form>
      </el-row>
    </el-dialog>
  </basic-container>
</template>

<script>
import {
  save,
  shopSelections,
  getList,
  remove,
  update,
  getCouponShopRecordList, //优惠券下拉框接口
  getCouponReceiveNumSumByShopId,
  getCouponSumByShopId,
  sendCouponsToCar,
  getCouponNumByShopId,
  cancel,
} from '@/api/v4ward/park/couponv2/giveout/carcoupongiveout';

 import {getToken} from '@/util/auth';
import { getSpaceTree } from '@/api/v4ward/carv2/carparkspace';
import { isvalidatemobile } from '@/util/validate';
import func from '@/util/func';
import qrcode from 'qrcodejs2';
import urlSettings from '@/config/url-settings.js';
export default {
  data() {
    const validatePhone = (rule, value, callback) => {
      if (isvalidatemobile(value)[0]) {
        callback(new Error(isvalidatemobile(value)[1]));
      } else {
        callback();
      }
    };
    return {
      qtimeStart:'',
      qtimeEnd:'',
      // plateNumberList:'',
      onePersonGetCouponNumList: [
        {
          onePersonGetCouponNum: 1,
        },
      ],
      selectionList: [],
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      totalCoupons: 0,
      usedCoupons: 0,
      title: '优惠券派发',
      shopSelectionsList: [], //商家下拉框数据
      shopId: '', //商家id
      spaceList: [], //车场下拉框数据
      parkingLotIdQuery: '', //车场id
      couponShopRecordList: [], //优惠券下拉框数据
      couponId: '', //优惠券id

      option: {
        height: 'auto',
        calcHeight: 55,
        labelWidth: 115,
        tip: false,
        viewBtn: false,
        delBtn: false,
        searchShow: true,
        searchMenuSpan: 24,
        searchMenuPosition: 'right',
        border: true,
        index: true,
        selection: false,
        dialogClickModal: false,
        align: 'left',

        //menu: false,
        columnBtn: true,
        refreshBtn: true,
        emptyBtn: true,
        addBtn: false,
        menuWidth: 160,
        searchBtn: true,
        editBtn: false,
        searchLabelWidth: 100,
        stripe: true,
        column: [
          {
            label: '派发时间',
            prop: 'issueTime',
            width: 140,
          },
          {
            label: '车场名称',
            prop: 'spaceName',
          },
          {
            label: '车场名称',
            prop: 'parkingLotId',
            type: 'select',
            hide: true,
            search: true,
            searchSpan: 6,
            showColumn: false,
            searchslot: true,
            dicData: [],
            width: 150,
            props: {
              label: 'title',
              value: 'id',
              disabled: 'disabled',
            },
            rules: [
              {
                required: true,
                message: '请选择车场名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '商家名称',
            prop: 'shopId',
            type: 'select',
            overHidden: true,
            //display: false,
            searchSpan: 6,
            search: true,
            hide: true,
            showColumn: false,
            dicData: [],
            searchslot: true,
            props: { label: 'shopName', value: 'id' },
          },
          {
            label: '派发时间',
            prop: 'giveOutTimeRange',
            hide: true,
            clearable: false,
            type: 'select',
            display: false,
            showColumn: false,
            searchSpan: 12,
            required: true,
            rules: [
              {
                required: true,
                message: '请选择时间段后再查询',
                trigger: 'blur',
              },
            ],
            search: true,
            searchslot: true,
          },
          {
            label: '商家名称',
            prop: 'shopName',
            type: 'select',
            overHidden: true,
            searchSpan: 6,
            dicData: [],
            props: { label: 'shopName', value: 'id' },
          },
          {
            label: '优惠券名称',
            prop: 'couponName',
            searchSpan: 6,
            search: true,
            searchslot: true,
            overHidden: true,

            rules: [
              {
                required: true,
                message: '请输入优惠券名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '优惠券类型',
            prop: 'couponType',
            dataType: 'number',
            type: 'select',
            width: 100,
            dicUrl: '/api/blade-system/dict/dictionary?code=car_coupon_type',
            props: { label: 'dictValue', value: 'dictKey' },
          },
          {
            label: '优惠券数量',
            prop: 'couponNum',
          },
          {
            label: '已领数量',
            prop: 'receiveNum',
          },
          {
            label: '优惠券有效期',
            prop: 'couponExpireDate',
            // type: 'date',
            // format: 'yyyy-MM-dd',
            // valueFormat: 'yyyy-MM-dd 00:00:00',
            width: 140,
            rules: [
              {
                required: true,
                message: '请输入优惠券有效截止日期',
                trigger: 'change',
              },
            ],
          },
          {
            label: '领用时车辆在场',
            prop: 'getCouponIsCarIn',
            type: 'radio',
            dicData: [
              {
                label: '是',
                value: 0,
              },
              {
                label: '否',
                value: 1,
              },
            ],
            rules: [
              {
                required: true,
                trigger: 'blur',
              },
            ],
          },
          {
            label: '同一用户领取优惠券数量',
            dataType: 'select',
            prop: 'onePersonGetCouponNum',
          },
          {
            label: '二维码有效期',
            prop: 'expireDate',
            width: 140,
            rules: [
              {
                required: true,
                message: '请输入有效截止日期',
                trigger: 'change',
              },
            ],
          },
          {
            label: '发券人',
            prop: 'sendName',
          },
          {
            label: '优惠券总数',
            prop: 'totalCoupons',
            searchslot: true,
            search: true,
            showColumn: false,
          },

          {
            label: '使用数量',
            prop: 'usedCoupons',
            searchslot: true,
            search: true,
            showColumn: false,
          },

          {
            label: '商家余额',
            hide: true,
            searchslot: true,
            search: true,
            showColumn: false,
            prop: 'shopBalance',
          },
          {
            label: '备注信息',
            prop: 'remark',
            type: 'textarea',
            maxlength: 100,
            showWordLimit: true,
            overHidden: true,
            span: 24,
          },
        ],
      },
      shopBalance: '',
      disabled: false,
      data: [],
      couponList: [],
      //未删除的商家且未欠费的商家
      shopNormalList: [], //新增表单里面的商家下拉框数据
      filterLetterList: [],
      parkingLotId: '',
      firstDisplayFlag: true,
      showCouponGiveOutDialog: false,
      showCouponGiveOutToCarDialog: false,
      giveOutTimeRange: '',
      giveOutForm: {
        remark: '',
        getCouponIsCarIn: '',
        couponNum: '',
        couponExpireDate: '',
        parkingLotId: '',
        shopId: '',
        couponId: '',
        expireDate: '',
        plateNumberList: '',
      },
      submitFlag: true,
    };
  },
  activated() {
    let self = this;
    setTimeout(() => {
      this.$refs.crud.doLayout(); //解决表格错位
    }, 0);
  },
  watch: {
    '$route.path': function (newVal, oldVal) {
      if (newVal === '/v4ward/park/couponv2/giveout/carcoupongiveout') {
        this.$refs.crud.$refs.table.doLayout();
      }
    },
  },
  computed: {
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  mounted() {
    window.onresize = () => {
      this.$refs.crud.$refs.table.doLayout();
    };
  },
  created() {
    this.initData();
    this.$nextTick(() => {
      setTimeout(() => {
        console.log(this.$refs.crud.$children[1]);
        this.$refs.crud.$children[1].$children[3].$el.addEventListener('click', () => {
          if (this.option.height == this.bodyHeight - 410) {
            this.option.height = this.bodyHeight - 280;
          } else {
            this.option.height = this.bodyHeight - 410;
          }
          this.$refs.crud.getTableHeight();
        });
      });
    });
    this.option.height = this.bodyHeight - 410;
  },
  methods: {
    // 初始化数据
    async initData() {
      console.log('初始化数据');
      //var startTime = func.() + ' 00:00:00';
      //var endTime = func.getCurrentDay() + ' 23:59:59';
      //this.giveOutTimeRange = [startTime, endTime];

      // 获取车场下拉框
      await getSpaceTree().then((data) => {
        this.spaceList = data.data;
        this.parkingLotIdQuery = this.spaceList[0] ? this.spaceList[0].id : '';
      });
      // if(!this.parkingLotIdQuery){
      //   this.onLoad();
      //     return;
      // }
      // 获取商家下拉框
      await shopSelections({ parkingLotId: this.parkingLotIdQuery, byShopUser: 1 }).then((res) => {
        this.shopSelectionsList = res.data;
        this.shopId = this.shopSelectionsList[0] ? this.shopSelectionsList[0].id : '';
        console.log('this.shopSelectionsList>>>>', this.shopSelectionsList);
        if (!this.shopSelectionsList) {
          this.$message.error('暂无商家');
        } else {
          if (!this.shopId) {
            this.$message.error('暂无商家');
          }
        }
      });
      // if(!this.shopId){
      //     this.onLoad();
      //     return;
      // }
      // 获取优惠券下拉框数据
      await getCouponShopRecordList({ shopId: this.shopId }).then((res) => {
        this.couponShopRecordList = res.data;
        // this.couponId = this.couponShopRecordList?this.couponShopRecordList.couponId:'';
      });
      this.onLoad();
    },
    // 获取二维码
    getQrcode(id, fileName) {
      window.open(`/api/v4ward/car/qrcode/carCoupon/v2?Blade-Auth=${getToken()}
        &baseUrl=${location.origin}&carCouponIssueId=${id}`);
    },
    // 解析base64
    getBlob(base64) {
      var mimeString = base64.split(',')[0].split(':')[1].split(';')[0]; // mime类型
      var byteString = atob(base64.split(',')[1]); //base64 解码
      var arrayBuffer = new ArrayBuffer(byteString.length); //创建缓冲数组
      var intArray = new Uint8Array(arrayBuffer); //创建视图
      for (var i = 0; i < byteString.length; i += 1) {
        intArray[i] = byteString.charCodeAt(i);
      }
      return new Blob([intArray], {
        type: mimeString,
      });
    },
    // 获取商家下拉框
    shopSelections(type) {
      if (type == 'search') {
        //搜索表单中的获取下拉框数据
        shopSelections({ parkingLotId: this.parkingLotIdQuery, byShopUser: 1 }).then((res) => {
          this.shopSelectionsList = res.data;
          this.shopId = this.shopSelectionsList[0] ? this.shopSelectionsList[0].id : '';
          if (this.shopId) {
            this.getCouponShopRecordList('search');
          }
        });
      }
      if (type == 'add') {
        //弹窗表单数据中获取下拉框数据
        shopSelections({ parkingLotId: this.giveOutForm.parkingLotId, byShopUser: 1 }).then(
          (res) => {
            this.shopNormalList = res.data;
            if (this.shopId) {
              this.giveOutForm.shopId = this.shopId;
            } else {
              this.giveOutForm.shopId = this.shopNormalList[0] ? this.shopNormalList[0].id : '';
            }
            if (this.giveOutForm.shopId) {
              this.getCouponShopRecordList('add');
            }
          }
        );
      }
      if (type == 'edit') {
        //弹窗表单数据中获取下拉框数据
        shopSelections({ parkingLotId: this.giveOutForm.parkingLotId, byShopUser: 1 }).then(
          (res) => {
            this.shopNormalList = res.data;
            if (this.giveOutForm.shopId) {
              this.getCouponShopRecordList('edit');
            }
          }
        );
      }
    },
    // 获取优惠券下拉框 type 用来控制不同表单中的
    getCouponShopRecordList(type) {
      if (type == 'search') {
        getCouponShopRecordList({ shopId: this.shopId }).then((res) => {
          this.couponShopRecordList = res.data;
          this.couponId = '';
          // this.couponId = this.couponShopRecordList[0]?this.couponShopRecordList[0].couponId:'';
        });
      }
      if (type == 'add') {
        getCouponShopRecordList({ shopId: this.giveOutForm.shopId }).then((res) => {
          this.couponList = res.data;
          this.giveOutForm.couponId = '';
          // this.giveOutForm.couponId = this.couponList[0]?this.couponList[0].couponId:'';
        });
      }
      if (type == 'edit') {
        getCouponShopRecordList({ shopId: this.giveOutForm.shopId }).then((res) => {
          this.couponList = res.data;
        });
      }
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    openSendCouponDialog(row) {
      if (!row) {
        if (this.selectionList.length === 0) {
          this.$message.warning('请选择至少一条数据');
          return;
        }
      }
      this.disabled = true;
      this.giveOutForm = {
        parkingLotId: row.parkingLotId,
        shopId: row.shopId,
        couponId: row.couponId,
        id: row.id,
        couponExpireDate: row.couponExpireDate,
        getCouponIsCarIn: row.getCouponIsCarIn,
        couponNum: row.couponNum,
        couponName: row.couponName,
        couponType: row.couponType,
        receiveNum: row.receiveNum,
      };
      this.plateNumberList = '';
      this.shopSelections('edit');
      this.showCouponGiveOutToCarDialog = true;
    },
    sendCouponsToCar() {
      // this.giveOutForm.plateNumberList = this.plateNumberList;
      sendCouponsToCar(this.giveOutForm).then(
        () => {
          this.onLoad();
          this.$message.success('发券成功!');
          this.showCouponGiveOutToCarDialog = false;
        },
        (error) => {
          this.$alert(error.msg, '发券失败').then(() => {});
          /*this.$confirm("以下车辆未发券成功，可能原因:车辆不在停车场内/商家余额不足/优惠券数量不足/车辆未绑定公众号等", {
          confirmButtonText: "确定",
          type: "warning"
        }).then(() => {
          this.showCouponGiveOutDialog = false;
          this.onLoad();
        });*/
          // window.console.log(error);
        }
      );
    },
    // 打开弹窗
    beforeOpen(type, row) {
      this.submitFlag = true;
      if (type == 'add') {
        this.title = '新增';
        this.disabled = false;
        this.giveOutForm = {
          parkingLotId: '',
          shopId: '',
          couponId: '',
          expireDate: '',
          getCouponIsCarIn: 0,
        };
        if (this.parkingLotIdQuery) {
          this.giveOutForm.parkingLotId = this.parkingLotIdQuery;
          this.shopSelections('add');
        } else if (this.spaceList.length > 0) {
          this.giveOutForm.parkingLotId = this.spaceList[0].id;
          this.shopSelections('add');
        }
        this.showCouponGiveOutDialog = true;
      }
      if (type == 'edit') {
        this.title = '编辑';
        this.disabled = true;
        this.giveOutForm = row;
        this.giveOutForm = {
          parkingLotId: row.parkingLotId,
          shopId: row.shopId,
          couponId: row.couponId,
          expireDate: row.expireDate,
          id: row.id,
          couponExpireDate: row.couponExpireDate,
          couponNum: row.couponNum,
          onePersonGetCouponNum: row.onePersonGetCouponNum,
          getCouponIsCarIn: row.getCouponIsCarIn,
          remark: row.remark,
        };
        this.shopSelections('edit');
        this.showCouponGiveOutDialog = true;
      }
    },
    // 保存提交方法
    saveData() {
      this.$refs.giveOutForm.validate((valid) => {
        if (valid) {
          if (!this.submitFlag) {
            return;
          }
          this.submitFlag = false;
          this.giveOutForm.expireDate = this.dayjs(this.giveOutForm.expireDate).format(
            'YYYY-MM-DD HH:mm:ss'
          );
          this.giveOutForm.couponExpireDate = this.dayjs(this.giveOutForm.couponExpireDate).format(
            'YYYY-MM-DD HH:mm:ss'
          );
          if (this.title == '编辑') {
            // 编辑
            update(this.giveOutForm).then(
              () => {
                this.onLoad();
                this.$message.success('操作成功!');
                this.submitFlag = true;
                this.showCouponGiveOutDialog = false;
              },
              (error) => {
                this.submitFlag = true;
                window.console.log(error);
              }
            );
          } else {
            // 新增
            save(this.giveOutForm).then(
              () => {
                this.onLoad();
                this.$message.success('操作成功!');
                this.submitFlag = true;
                this.showCouponGiveOutDialog = false;
              },
              (error) => {
                this.submitFlag = true;
                window.console.log(error);
              }
            );
          }
        } else {
        }
      });
    },

    //派发表单中修改了车场
    giveOutParkingLotChange(value) {
      this.giveOutForm.couponId = '';
      this.giveOutForm.shopId = '';
      this.shopSelections('add');
    },
    // 发券表单商家切换
    shopChanged() {
      this.giveOutForm.couponId = '';
      this.getCouponShopRecordList('add');
    },
    // 搜索表单车场切换
    parkingLotQueryChanged(value) {
      console.log("value", value);
      this.shopId = '';
      this.couponId = '';
      this.shopSelections('search');
    },
    // 搜索表单商家切换
    searchShopChange(value) {
      this.couponId = '';
      this.getCouponShopRecordList('search');
    },
    // 搜索
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },

    // 切换页
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    // 切换一页接收多少条数据
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    searchReset() {
      this.giveOutTimeRange = '';
      this.couponId = '';
      this.qtimeStart=''
        this.qtimeEnd=''
      this.page.currentPage = 1;
      this.onLoad();
    },

    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      this.query.parkingLotId = this.parkingLotIdQuery;
      this.query.shopId = this.shopId;
      this.query.couponId = this.couponId;
      // if(!this.query.shopId){
      //   this.loading = false;
      //   return;
      // }
      // if( this.vdui.isEmpty(this.qtimeStart)||this.vdui.isEmpty(this.qtimeEnd)){
      //   console.log("****")
      //   this.qtimeStart=''
      //   this.qtimeEnd=''
      // }
      this.query.timeStart = this.qtimeStart;
        this.query.timeEnd = this.qtimeEnd


      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query))
        .then(({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.shopBalance = this.data[0] ? this.data[0].shopBalance : 0;
          this.loading = false;
          this.selectionClear();
        })
        .catch((err) => {
          this.loading = false;
        });
      // 获取已使用优惠券数量
      getCouponReceiveNumSumByShopId(this.query).then((res) => {
        this.usedCoupons = res.data;
      });
      // 获取优惠券总数
      getCouponNumByShopId(this.query).then((res) => {
        this.totalCoupons = res.data;
      });
    },
  },
};
</script>

<style>
#coupon_give_out .el-dialog__body {
  padding-right: 60px;
}
#coupon_give_out_to_car .el-dialog__body {
  padding-right: 60px;
}

#button-back .el-button + .el-button {
  margin-left: 50px;
  margin-top: 20px;
  margin-bottom: 20px;
}

#button-back .el-button--small {
  padding: 9px 20px;
}
#button-back_to_car .el-button + .el-button {
  margin-left: 50px;
  margin-top: 20px;
  margin-bottom: 20px;
}

#button-back_to_car .el-button--small {
  padding: 9px 20px;
}
</style>
<style scoped>
::v-deep .avue-form__menu--center {
  text-align: right;
}
::v-deep .avue-crud__search .el-form-item--small.el-form-item {
  width: 100%;
}
#button-back .avue-form__menu {
  text-align: right;
}
</style>
<style scoped>
::v-deep .avue-form__menu--center {
  text-align: right;
}
::v-deep .avue-crud__search .el-form-item--small.el-form-item {
  width: 100%;
}
</style>
